module.exports = __webpack_public_path__ + "static/media/report_logo.9fa7ca9d.png";